/**
 * Ouvre une URL externe (lien `t.me`, http(s)…) dans le navigateur / l'appli
 * système.
 *
 * Pourquoi ce helper : dans l'app desktop (webview Tauri), un
 * `<a target="_blank">` ne fait RIEN — Tauri n'a pas de gestionnaire de
 * nouvelle fenêtre, et l'intercepteur natif `on_navigation` (src-tauri/src/lib.rs)
 * ne redirige vers le navigateur système QUE les URLs OAuth, pas les liens
 * arbitraires. Résultat : les deeplinks d'invitation Telegram ne s'ouvraient pas
 * dans l'app desktop.
 *
 * Côté web (dozka.app dans un navigateur), `window.open` suffit. Côté Tauri, on
 * passe par `@tauri-apps/plugin-shell` `open()` (le plugin Rust est déjà
 * enregistré + la capability `shell:allow-open` est accordée → aucun rebuild
 * Tauri nécessaire, c'est un changement 100 % web déployé via Dokploy).
 */

const IS_IN_TAURI =
  typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;

export async function openExternalUrl(url: string): Promise<void> {
  if (IS_IN_TAURI) {
    try {
      const { open } = await import("@tauri-apps/plugin-shell");
      await open(url);
      return;
    } catch (err) {
      // Si le plugin shell échoue (capability absente d'un vieux build, etc.),
      // on retombe sur window.open — best-effort plutôt que bouton mort.
      console.error("openExternalUrl: échec Tauri shell.open, fallback", err);
    }
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Handler de clic pour un `<a href>` : préserve le comportement natif du
 * navigateur (clic-milieu, copier le lien) en web, et bascule sur l'ouverture
 * système en Tauri (où `target="_blank"` est inopérant).
 */
export function handleExternalLinkClick(
  e: { preventDefault: () => void },
  url: string,
): void {
  if (IS_IN_TAURI) {
    e.preventDefault();
    void openExternalUrl(url);
  }
}
